import React from 'react';
import { ProductPage } from './pages/ProductPage';
export function App() {
  return <ProductPage data-id="element-0" />;
}